/**
 * Mirrors looksLikeDeckEdit in mic-backend/src/services/mcpQuiz/editPendingPresentation.js.
 * True when a message edits the pending deck ("remove slide 3, make slide 2 easier")
 * rather than asking for a new presentation.
 */
export function looksLikeDeckEdit(text) {
  const t = String(text || "").toLowerCase();
  if (!t.trim() || /^(presentation_|propose_presentation|__)/.test(t.trim())) return false;
  if (/\b(new|another)\s+(presentation|deck)\b/.test(t)) return false;
  const refersToSlide =
    /\bslides?\s*(#\s*)?\d+\b/.test(t) ||
    /\b(first|second|third|fourth|fifth|sixth|seventh|eighth|ninth|tenth|last|final)\s+slide\b/.test(t) ||
    /\b(add|insert)\s+(a\s+|an\s+|one\s+)?(new\s+)?slide\b/.test(t);
  const editVerb =
    /\b(remove|delete|drop|add|insert|make|change|rename|retitle|rewrite|simplify|shorten|expand|move|swap|duplicate|copy|replace|put|use|easier|simpler|harder)\b/.test(t);
  return refersToSlide && editVerb;
}
